import "core-js/modules/es.array.map";
import React from "react";
import DragRail from "web/react/components/drag-rail/drag-rail";
import analytics from "web/script/analytics/analytics";
import styles from "./homepage-most-wanted-rail.css";

function HomepageMostWantedItem(_ref) {
  var item = _ref.item;
  return React.createElement("div", {
    className: styles.homepageMostWantedItem
  }, React.createElement("a", {
    className: styles.homepageMostWantedItemText,
    href: item.url
  }, item.title));
}

export function HomepageMostWantedRail(_ref2) {
  var items = _ref2.items;
  var id = "homepage-most-wanted-rail";

  function handleDrag() {
    analytics.event("rail", "drag", id);
  }

  return React.createElement(DragRail, {
    id: id,
    onDragStart: handleDrag,
    className: styles.homepageMostWantedRail
  }, React.createElement("div", {
    className: styles.homepageMostWantedRailContent
  }, items.map(function (item) {
    return React.createElement(HomepageMostWantedItem, {
      key: item.url,
      item: item
    });
  })));
}

function HomepageMostWantedRails(_ref3) {
  var sectionTitle = _ref3.section_title,
      womensLinks = _ref3.womens_links,
      mensLinks = _ref3.mens_links;
  return React.createElement("div", {
    className: styles.homepageMostWantedBase
  }, React.createElement("div", null, React.createElement("h4", {
    className: styles.homepageMostWantedTitle
  }, sectionTitle)), React.createElement("div", {
    className: styles.homepageMostWantedContent
  }, React.createElement(HomepageMostWantedRail, {
    items: mensLinks
  }), React.createElement(HomepageMostWantedRail, {
    items: womensLinks
  })));
}

export default HomepageMostWantedRails;